import React, { useEffect } from "react";
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Paper, Button } from "@mui/material";
import { useStore } from "../../app/stores/store";
import { useTranslation } from "react-i18next";

export default function EmailLogPage() {
  const emailLogStore = useStore((s) => s.emailLogStore);
  const { t } = useTranslation();

  useEffect(() => {
    emailLogStore.fetchLogs();
  }, [emailLogStore.fetchLogs]);

  return (
    <TableContainer component={Paper} sx={{ mt: 2 }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>{t("emails.logs.recipients")}</TableCell>
            <TableCell>{t("emails.logs.subject")}</TableCell>
            <TableCell>{t("emails.logs.sentAt")}</TableCell>
            <TableCell>{t("emails.logs.status")}</TableCell>
            <TableCell>{t("emails.logs.actions")}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {emailLogStore.logs.map(log => (
            <TableRow key={log.id}>
              <TableCell>
                {Array.isArray(log.recipients)
                  ? log.recipients.join(", ")
                  : log.recipients}
              </TableCell>
              <TableCell>{log.subject}</TableCell>
              <TableCell>{log.sentAt}</TableCell>
              <TableCell>{log.status}</TableCell>
              <TableCell>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={() => emailLogStore.downloadLogPdf(log.id)}
                >
                  {t("emails.logs.downloadPdf")}
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
